import React from 'react';
import { Dropdown } from 'react-bootstrap';

// This is a simple single selector dropdown (RESUABLE)
// options => expected data is an array of objects in label, value format or in single array format
// onSelectItemChange => function to be called on selection change and will return selected keyName
// valueName => display text and keyName => passed to server text
// dropdownName => dropdown name for selected value function 
// toggleClass,menuClass => dropdown toggle and menu css classes

// eg => options = [{keyName: '1', valueName: 'option 1'}, {keyName: '2', valueName: 'option 2'}] returns keyName: '1'
// eg => options = ['option 1', 'option 2'] returns 'option 1'

const SingleSelectDropdown = ({
    options = [],
    onSelectItemChange,
    keyName,
    valueName,
    selectedValue,
    dropdownName,
    placeholder,
    toggleClass,
    menuClass,
}) => {
    const getOptionsKey = (option) =>
        typeof option === 'object' ? option[keyName] : option
    const getOptionsValue = (option) =>
        typeof option === 'object' ? option[valueName] : option
    const getSelectedOption = (option) =>
        selectedValue ? option.find((o) => o[keyName] === selectedValue)?.[valueName] || selectedValue : placeholder
    return (
        <Dropdown
            data-bs-theme="dark"
            autoClose="true"
            className="reactDropdownRootClass halfWidth contents"
            name={dropdownName}
            onSelect={(eventKey) => onSelectItemChange(eventKey, dropdownName)}

        >
            <Dropdown.Toggle
                variant="secondary"
                id={`operation-dropdown-${dropdownName}`}
                className={`dropdown-display-class halfWidth ${toggleClass || ''}`}
            >
                {getSelectedOption(options)}
            </Dropdown.Toggle>
            <Dropdown.Menu className={`reactDropdownMenuClass halfWidth dropdown-menu-class ${menuClass || ''}`}>
                {options.map((option) => (
                    <Dropdown.Item
                        key={getOptionsKey(option)}
                        eventKey={getOptionsKey(option)}
                        className="dropdown-item-class"
                    >
                        {getOptionsValue(option)}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default SingleSelectDropdown;